export default __webpack_public_path__ + "f862b0f4608b4f0fb945113ef8dcdfa3.woff2";